// Payment proof photo attached to a receipt (payment_proof on POST/PUT /api/receipts)
export const PAYMENT_PROOF_ACCEPT = 'image/png,image/jpeg,image/webp,image/heic';
export const PAYMENT_PROOF_MAX_SIZE = 5 * 1024 * 1024;

const PAYMENT_PROOF_TYPES = PAYMENT_PROOF_ACCEPT.split(',');
const PAYMENT_PROOF_EXTENSIONS = /\.(png|jpe?g|webp|heic)$/i;

// Browsers other than Safari can't render HEIC, so previews fall back to an icon
export const isHeicFile = (file) => /hei[cf]/i.test(file?.type || '') || /\.hei[cf]$/i.test(file?.name || '');

// Returns the API's own error message, or null when the file can be sent
export const validatePaymentProof = (file) => {
    if (!file) return null;
    // Some browsers report HEIC with an empty MIME type, so fall back to the extension
    const typeOk = PAYMENT_PROOF_TYPES.includes(file.type) || (!file.type && PAYMENT_PROOF_EXTENSIONS.test(file.name));
    if (!typeOk) return 'Payment proof must be a PNG, JPG, WebP or HEIC image';
    if (file.size > PAYMENT_PROOF_MAX_SIZE) return 'Payment proof must be under 5MB';
    return null;
};

const API_ORIGIN = (process.env.REACT_APP_NODE_MOBILE_BASE_URL || '').replace(/\/+$/, '');

// payment_proof_view_url is a signed link (expires in 15 min) with cloud storage, or a
// relative /uploads/... path served from the API host when files are kept on disk
export const resolvePaymentProofUrl = (viewUrl) => {
    if (!viewUrl) return '';
    if (/^(https?:|blob:|data:)/i.test(viewUrl)) return viewUrl;
    return `${API_ORIGIN}/${String(viewUrl).replace(/^\/+/, '')}`;
};
